// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-amendments.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-amendments/flight-plan-amendments.js';

mount([g0]);
